<div class="lang-switcher theme-footer-background theme-select-bc">
    <mat-form-field color="accent">
        <mat-select
            (selectionChange)="setLanguage(config.language)"
            [(ngModel)]="config.language"
            [aria-label]="'Selectionner la langue' | transloco"
        >
            <mat-option
                (click)="setLanguage(language)"
                *ngFor="let language of languages"
                [attr.aria-label]="language | localeToLanguage"
                [value]="language"
                class="lang-switcher-options"
                mat-option
            >
                {{ language | titlecase }}
            </mat-option>
        </mat-select>
    </mat-form-field>
</div>
